﻿﻿﻿<service-ticket-menu (outputDownload)="downloadServiceTicketFiltered()" (onReload)="onReload()"></service-ticket-menu>
<h2>{{title}} for {{defaults.tenant}}</h2>
<service-ticket-filter (outputFilter)="getFilteredServiceTicketsByTenant()"></service-ticket-filter>
<service-ticket-list [list]="list" [showLocalFilter]="showLocalFilter"></service-ticket-list>